import React from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { VStack, FormControl, FormErrorMessage, Button } from "@chakra-ui/react";
import { ArrowForwardIcon } from "@chakra-ui/icons";
import { ThemedFormLabel } from "../../../homeowners/hire/themed-form-label";
import { ThemedInput } from "../../../homeowners/hire/themed-input";
import {
  CompanyInformationFormData,
  companyInformationSchema,
} from "../../schemas/schema";

interface CompanyInformationStepProps {
  onStepComplete: (data: CompanyInformationFormData) => void;
  isLoading?: boolean;
  defaultValues?: Partial<CompanyInformationFormData>;
}

export const CompanyInformationStep: React.FC<CompanyInformationStepProps> = ({
  onStepComplete,
  isLoading = false,
  defaultValues,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<CompanyInformationFormData>({
    resolver: zodResolver(companyInformationSchema),
    defaultValues,
  });

  const onSubmit = (data: CompanyInformationFormData) => {
    onStepComplete(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <VStack spacing={6} align="stretch">
        <FormControl isInvalid={!!errors.organization}>
          <ThemedFormLabel>Organization Name</ThemedFormLabel>
          <ThemedInput
            {...register("organization")}
            placeholder="Enter your organization name"
          />
          <FormErrorMessage>{errors.organization?.message}</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={!!errors.roleInOrganization}>
          <ThemedFormLabel>Your Role in Organization</ThemedFormLabel>
          <ThemedInput
            {...register("roleInOrganization")}
            placeholder="e.g., Community Manager, Admin"
          />
          <FormErrorMessage>
            {errors.roleInOrganization?.message}
          </FormErrorMessage>
        </FormControl>

        <Button
          type="submit"
          size="lg"
          w="full"
          colorScheme="flatteredFlamingo"
          rightIcon={<ArrowForwardIcon />}
          isLoading={isLoading}
          loadingText="Processing..."
          mt={4}
        >
          Next
        </Button>
      </VStack>
    </form>
  );
};


